<span class="value" [class.fillrateGlobal]="fillrateGlobal" [class.fillrateGlobalFull]="fillrateGlobalFull" [innerHTML]="getFormattedValue()"></span>

